import { forwardRef, useLayoutEffect, useMemo, useState } from "react";
import { staticUrl } from "services/data/mainUrl";
import styles from "./Apps.module.css";
import { DataGrid, gridClasses, GRID_CHECKBOX_SELECTION_COL_DEF } from "@mui/x-data-grid";

const appNameRenderer = ({id, value}) => {
  return ( <div className={styles.appName}>
            <div className={styles.title}>{value.name}</div>
            <div className={styles.package}>{value.package}</div>
          </div>
  );
};

const Apps = forwardRef(({items, apiRef, onChange}, ref) => {
  
  const [selectedRows, setSelectedRows] = useState([]);

  useLayoutEffect( () => { 
    return () => {
      onChange([]);
    }
  }, []);

  const columns = useMemo( () => [
      {field: 'icon', width: 50, display: 'flex', align: 'center', sortable: false, 
        renderCell: (params) => <img className={styles.icon} src={`${staticUrl}${params.row.icon}`} />},
      {field: 'app', flex: 1, valueGetter: (value, row) => ({name: row.name, package: row.package}), renderCell: appNameRenderer, display: 'flex'},
      {...GRID_CHECKBOX_SELECTION_COL_DEF}  
    ], [items]
  );

  const onModelChange = (newSelectedRows) => {
    setSelectedRows(newSelectedRows);
    onChange(newSelectedRows);
  };

  return (
    <div ref={ref}>
      <DataGrid
        getRowId={(row) => row.package}
        editMode="row"
        apiRef={apiRef}
        className={styles.apps}
        rows={items}
        rowSelectionModel={selectedRows}
        localeText={{noRowsLabel: "Приложений пока нет"}}
        onRowSelectionModelChange={onModelChange}
        columns={columns}
        columnHeaderHeight={1}
        checkboxSelection
        disableColumnResize
        disableColumnMenu
        disableRowSelectionOnClick
        disableMultipleRowSelection
        hideFooter
        sx={{
          [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
            outline: 'none',
          },
          [`& .${gridClasses.columnHeader}, & .MuiInputBase-root`]: {
            overflowX: 'unset'
          },
          [`& .${gridClasses.cell}.${gridClasses["cell--editing"]}:focus, & .${gridClasses.cell}.${gridClasses["cell--editing"]}:focus-within`]: {
            outline: 'none'
          }
        }}
      />
      
    </div>
  );
});

export default Apps;